import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ReviewsAdminWidget from "../components/ReviewsAdminWidget";

const ReviewsAdminPage: React.FC = () => {
  const { profile, isAuthenticated } = useAuth();
  const [userProfile, setUserProfile] =
    React.useState<ProfileAndSettings | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    profile()
      .then((p) => {
        setUserProfile(p);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [profile]);

  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  if (loading)
    return (
      <div className="flex items-center justify-center p-12 text-gray-500">
        A carregar...
      </div>
    );

  // Client-side gate — real enforcement is api-gw + reviews-ms ModeratorJIT
  if (!userProfile?.isAdmin() && !userProfile?.isCommercial())
    return <Navigate to="/" replace />;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-bold mb-2 text-gray-800">
          Gestão de Avaliações
        </h1>
        <p className="mb-6 text-gray-500 text-sm">
          Aprove, rejeite ou remova avaliações de clientes. As avaliações
          aprovadas ficam visíveis nas páginas dos compostos.
        </p>
        <ReviewsAdminWidget
          authToken={localStorage.getItem("authToken") || undefined}
          locale="pt"
        />
      </div>
    </div>
  );
};

export default ReviewsAdminPage;
